import HomeDashboardBody from "./_components/HomeDashboardBody";

export default function HomePage() {
  return <HomeDashboardBody />;
}
